import axios from './axios';
import { LoggerError } from '@/common/utils/elk-logger';

/**
 *采用API级别的缓存
 当接口是在服务端请求时，如果带有使用缓存的参数，则优先使用缓存
 */
class HttpRequest {
  /**
   * @param {*} api 接口名称
   * @param {*} options
   */
  async query({ url, options = {} }) {
    let method = (options.method || '').toString().toLowerCase();
    options.data = Object.assign({}, options.data || {});

    if (options.data && (!method || method === 'get' || method === 'delete')) {
      options.params = options.data;
      delete options.data;
    }

    let request = {
      url,
      timeout: 10 * 1000, // 默认10秒请求超时
      withCredentials: false, // 默认无需凭证
      ...options,
    };

    return axios(request)
      .then((rsp) => {
        return rsp;
      })
      .catch((err) => {
        const { config = {}, code, response = {} } = err?.rep || {};
        const errLog = `[error code]:${code}; [error api]:${config.url}; [err response]:${JSON.stringify(response.data)}`;
        LoggerError(err, {
          errReqUrl: url,
          errParams: options,
          message: errLog
        })
      });
  }
}

export default new HttpRequest();
